import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
declare var bettingLoader: any;

@Component({
    selector: 'app-databet',
    imports: [CommonModule],
    templateUrl: './databet.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './databet.component.scss'
})
export class DatabetComponent implements OnInit, OnDestroy {
  token = '';
  balance = '';
  state?: ToggleWidgetBetslipPayload;
  className = '';
  theme = '';
  projectName = '';
  constructor(private route: ActivatedRoute, private titleService: Title) {
    this.titleService.setTitle('Databet');
  }

  ngOnDestroy(): void {
    document.removeEventListener('betting-init', this.initBetting);
  }
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.token = params.get('token')!;
      this.balance = params.get('balance')!;
      this.theme = params.get('theme')!;
      this.projectName = params.get('project')!;
      const script = document.createElement('script');
      script.src = this.buildScriptUrl();
      script.type = 'module';
      script.onload = () => this.loadBetting();

      document.addEventListener('betting-init', this.initBetting);
      document.body.appendChild(script);
    });
  }

  private loadBetting(): void {
    bettingLoader.load(
      {
        url: { basename: '/' },
        token: this.getSecurityApiToken(),
        rootElement: 'betting__container',
        theme: this.updateTheme(),
        defaultSettings: { oddFormat: 'Decimal' },
      },
      (bettingAPI: BettingAPI) => {
        (window as any).bettingAPI = bettingAPI;
        document.dispatchEvent(new Event('betting-init'));
        bettingAPI.setUserBalance(this.getBalance());
        bettingAPI.registerCallbacks({
          getErrorTitle: (errorCode: string) => {
            switch (errorCode) {
              case 'player_limit_reached':
                return 'Bet limit exceeded'
              default:
                return 'this is the failure code' + errorCode;
            }
          }
        } as BettingCallbacks);
        bettingAPI.updateThemeConfig(this.updateTheme());
      }
    );
  }

  updateTheme(): Partial<ThemeConfig> {
    let results = {
      font: {
        baseFontSize: '',
        fontSans: ''
      },
      offsetTop: 0,
      palette: {
        betslipCTABtnText: '',
        colorsAccent1: '',
        colorsAccent2: '',
        colorsAccent3: '',
        colorsPrimary1: '',
        colorsPrimary2: '',
        colorsSecondary1: '',
        colorsSecondary2: '',
        colorsSecondary3: '',
        notificationBlocked: '',
        notificationError: '',
        notificationInfo: '',
        notificationSuccess: '',
        notificationWarning: '',
        colorsSportIcons: '',
        text: '',
        textButton: '',
        textOdd: '',
        textPrimary: '',
        textSecondary: ''
      },
      radius: {
        rounded12: '',
        rounded2: '',
        rounded24: '',
        rounded4: '',
        rounded6: '',
        rounded8: ''
      }
    }
    this.theme === 'dark' && this.projectName === environment.luckyFishProject ?
      results = environment.luckyFishTheme :
      this.theme === 'dark' ?
        results = {
          font: {
            baseFontSize: "16px",
            fontSans: "Roboto, sans-serif"
          },
          offsetTop: 0,
          palette: {
            betslipCTABtnText: "#ffffff",
            colorsAccent1: "#7d77ff",
            colorsAccent2: "#f6262e !important",
            colorsAccent3: "#ffdc00",
            colorsPrimary1: "#cddbf9",
            colorsPrimary2: "#0c121d",
            colorsSecondary1: "#0f1927",
            colorsSecondary2: "#20293b",
            colorsSecondary3: "#50628b",
            notificationBlocked: "#4c5a7b",
            notificationError: "#f40013",
            notificationInfo: "#0091d3",
            notificationSuccess: "#00b750",
            notificationWarning: "#ffbd00",
            colorsSportIcons: "#6d7097",
            text: "#ffffff",
            textButton: "#000000",
            textOdd: "#ffffff",
            textPrimary: "#ffffff",
            textSecondary: "#a1b3c9"
          },
          radius: {
            rounded12: "12px",
            rounded2: "2px",
            rounded24: "24px",
            rounded4: "4px",
            rounded6: "6px",
            rounded8: "8px"
          }
        } :
        results = {
          font: {
            baseFontSize: "16px",
            fontSans: "Roboto, sans-serif"
          },
          offsetTop: 0,
          palette: {
            colorsPrimary1: '#000000',
            colorsPrimary2: '#ffffff',
            colorsSecondary1: '#f3f3f3',
            colorsSecondary2: '#e3e3e3',
            colorsSecondary3: '#9999a1',
            colorsAccent1: '#a900d9',
            colorsAccent2: '#ffb700',
            colorsAccent3: '#a900d9 !important',
            textButton: '#ffffff',
            textPrimary: '#000000',
            textSecondary: '#656565',
            notificationBlocked: '#b5b5b5',
            notificationError: '#ff3e33',
            notificationInfo: '#0852ff',
            notificationSuccess: '#05BC0B',
            notificationWarning: '#ff9000',
            textOdd: '#000000 !important',
            betslipCTABtnText: '#000000 !important',
            text: '#fdf7f7 !important',
            colorsSportIcons: "#6d7097",
          },
          radius: {
            rounded12: "12px",
            rounded2: "2px",
            rounded24: "24px",
            rounded4: "4px",
            rounded6: "6px",
            rounded8: "8px"
          }

        }
    return results as ThemeConfig;
  }

  private initBetting = () => {
    if (!(window as any).bettingAPI) return;

    (window as any).bettingAPI.subscribe('toggle-widget-betslip', (payload: ToggleWidgetBetslipPayload) => {
      this.state = payload;
      this.updateClassName();
    });
  };

  private BetslipStyleGetter: Record<'static' | 'island', (data: IStypeBetslip) => string> = {
    static: ({ isOpen, breakpoint }: IStypeBetslip): string => {
      if (breakpoint === 'mobile') {
        if (isOpen) {
          document.body.classList.add('overflow-auto');
          return 'fixed top-16 left-0 z-40 h-4 lg:hidden w-full';
        } else {
          document.body.classList.remove('overflow-hidden');
          return 'fixed bottom-0 left-0 -z-40 w-full';
        }
      }
      if (breakpoint === 'tablet') {
        return 'fixed top-4 left-auto right-0 z-40 h-[100vh]';
      }
      return '';
    },
    island: ({ isOpen, breakpoint }): string => {
      if (breakpoint === 'mobile') {
        if (isOpen) {
          document.body.classList.add('overflow-auto');
          return 'fixed bottom-4 left-0 top-16 h-4 z-40 lg:hidden w-full';
        } else {
          document.body.classList.remove('overflow-hidden');
          return 'fixed bottom-0 left-0 z-40 w-full';
        }
      }
      if (breakpoint === 'tablet') {
        return 'fixed inset-x-1/2 bottom-0 z-[999999] w-full max-w-[320px] max-h-[100vh] -translate-x-1/2';
      }
      return 'fixed inset-x-1/2 bottom-0 z-[999999] w-full max-w-[320px] max-h-[80vh] -translate-x-1/2';
    }
  };

  private updateClassName(): void {
    if (!this.state) {
      this.className = '';
      return;
    }
    const getter = this.BetslipStyleGetter[this.state.widgetType] || this.BetslipStyleGetter['static'];
    this.className = getter({ isOpen: this.state.isOpen, breakpoint: this.state.breakpoint });
  }

  buildScriptUrl(): string {
    return environment.databet.boodstrap.replace('project-name', this.projectName)
  }

  getSecurityApiToken() {
    return this.token;
  }

  getBalance() {
    return this.balance;
  }
}

type IStypeBetslip = Pick<ToggleWidgetBetslipPayload, 'breakpoint' | 'isOpen'>;
interface ToggleWidgetBetslipPayload {
  breakpoint: 'mobile' | 'tablet' | 'desktop';
  isOpen: boolean;
  widgetType: 'static' | 'island';
}

interface BettingAPI {
  registerCallbacks(callbacks: BettingCallbacks): void;
  // subscribe(event: IBettingEvent, handler: (data: IBettingEventPayload) => void): () => void;
  updateBettingOptions(options: { token: string }): void;
  updateThemeConfig(themeConfig: Partial<ThemeConfig>): void;
  setUserBalance(balance: string): void;
  destroy(): void;
}

interface BettingCallbacks {
  getErrorTitle?: (errorCode: string) => string;
}


export interface ThemeConfig {
  font: {
    baseFontSize: string;
    fontSans: string;
  };
  offsetTop: number;
  palette: {
    betslipCTABtnText: string;
    colorsAccent1: string;
    colorsAccent2: string;
    colorsAccent3: string;
    colorsPrimary1: string;
    colorsPrimary2: string;
    colorsSecondary1: string;
    colorsSecondary2: string;
    colorsSecondary3: string;
    notificationBlocked: string;
    notificationError: string;
    notificationInfo: string;
    notificationSuccess: string;
    notificationWarning: string;
    text: string;
    textButton: string;
    textOdd: string;
    textPrimary: string;
    textSecondary: string;
    colorsSportIcons: string;
  };
  radius: {
    rounded12: string;
    rounded2: string;
    rounded24: string;
    rounded4: string;
    rounded6: string;
    rounded8: string;
  };
}